import React, { useRef } from "react";
import Workouts from "../../components/Workouts";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";

// import styles from "./Features.module.sass";
import HeroApprentissage from "./HeroApprentissage";
import FonctionnalitesContrat from "./FonctionnalitesContrat";
import AutomatisationContrats from "./AutomatisationContrats";
import ProcessusContrat from "./ProcessusContrat";
import AvantagesGestion from "./AvantageGestion";  
import Faq from "./Faq";


const Features = () => {
  const scrollToRef = useRef(null);

  const seoData = {
    title: "Contrat d'Apprentissage - Gestion automatisée pour CFA | Edutio",
    description: "Automatisez la création, le suivi et la validation de vos contrats d'apprentissage avec Edutio. Interface collaborative CFA, entreprises et alternants. Conformité OPCO garantie.",
    keywords: "contrat apprentissage, gestion CFA, démarches administratives, alternance, OPCO, formation professionnelle"
  };

  return (
    <>
      <SEOHead {...seoData} />
      <HeroApprentissage  scrollToRef={scrollToRef} />
      <AvantagesGestion  className="section-pb" scrollToRef={scrollToRef} />
      <ProcessusContrat  />
      <FonctionnalitesContrat />
      <AutomatisationContrats />
      <Workouts />
      <Faq />
      <AppelAction className="section" />
    </>
  );
};

export default Features;
